import api from '../../services/api';

const state = {
  products: [],
  currentProduct: null,
  loading: false,
  error: null,
  initialized: false
};

const getters = {
  allProducts: state => state.products,
  activeProducts: state => state.products.filter(p => p.status === 'active'),
  currentProduct: state => state.currentProduct,
  isLoading: state => state.loading,
  isInitialized: state => state.initialized
};

const actions = {
  async fetchProducts({ commit, state }) {
    // Prevent unnecessary refetches
    if (state.loading) return { success: true };
    
    commit('SET_LOADING', true);
    try {
      const response = await api.get('/products');
      commit('SET_PRODUCTS', response.data);
      commit('SET_INITIALIZED', true);
      return { success: true };
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.error || 'Failed to fetch products');
      return { success: false };
    } finally {
      commit('SET_LOADING', false);
    }
  },
  
  clearProducts({ commit }) {
    commit('SET_PRODUCTS', []);
    commit('SET_CURRENT_PRODUCT', null);
    commit('SET_INITIALIZED', false);
  },
  
  async fetchProduct({ commit }, id) {
    commit('SET_LOADING', true);
    try {
      const response = await api.get(`/products/${id}`);
      commit('SET_CURRENT_PRODUCT', response.data);
      return { success: true, data: response.data };
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.error || 'Failed to fetch product');
      return { success: false };
    } finally {
      commit('SET_LOADING', false);
    }
  },
  
  async createProduct({ commit, dispatch }, productData) {
    try {
      const response = await api.post('/products', productData);
      await dispatch('fetchProducts');
      return { success: true, data: response.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.error || 'Failed to create product' 
      };
    }
  },
  
  async updateProduct({ dispatch }, { id, data }) {
    try {
      const response = await api.put(`/products/${id}`, data);
      await dispatch('fetchProducts');
      return { success: true, data: response.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.error || 'Failed to update product' 
      };
    }
  },
  
  async deleteProduct({ dispatch }, id) {
    try {
      await api.delete(`/products/${id}`);
      await dispatch('fetchProducts');
      return { success: true };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.error || 'Failed to delete product' 
      };
    }
  },
  
  async activateProduct({ dispatch }, id) {
    try {
      await api.post(`/products/${id}/activate`);
      await dispatch('fetchProducts');
      return { success: true };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.error || 'Failed to activate product' 
      };
    }
  },
  
  async deactivateProduct({ dispatch }, id) {
    try {
      await api.post(`/products/${id}/deactivate`);
      await dispatch('fetchProducts');
      return { success: true };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.error || 'Failed to deactivate product' 
      };
    }
  }
};

const mutations = {
  SET_PRODUCTS(state, products) {
    state.products = products;
  },
  SET_CURRENT_PRODUCT(state, product) {
    state.currentProduct = product;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_INITIALIZED(state, initialized) {
    state.initialized = initialized;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};